import React, { useEffect, useState } from "react";
import Button from "@material-ui/core/Button";
import useBDocTranslator from "../hooks/useBDocTranslator";
import {
  MenuItem,
  TextField,
  Snackbar,
  CircularProgress,
} from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";
import Axios from "axios";
import useUserState from "../hooks/useUserState";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { prescTypes, presTypeObjLabel } from "./PrenscriptionDialog";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default function PrescriptionEHR({ appointmentId }) {
  const [pharmacies, setPharmacies] = useState([]);
  const [prescType, setPrescType] = useState();
  const { t } = useBDocTranslator();
  const userLocalState = useUserState();
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [pharmacy, setPharmacy] = useState(null);
  const [dispenseTo, setDispenseTo] = useState(null);
  const [prescriptionValue, setPrescriptionValue] = useState("");
  const [notes, setNotes] = useState("");
  const [enabledSave, setEnabledSave] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link"],
      ["clean"],
    ],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
  ];

  useEffect(() => {
    Axios.get(`${process.env.REACT_APP_API_URL_BASE}/pharmacy/findAll`, {
      headers: { Authorization: "Bearer " + userLocalState[0].jwt },
    })
      .then((response) => {
        setPharmacies(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  //Method for Save the prescription
  const handlePrescriptionSave = async () => {
    try {
      setIsLoading(true);
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL_BASE}/prenscriptions/create`,
        {
          appointment_id: appointmentId,
          patient_directions: prescriptionValue,
          medication_id: "1",
          dispense: "1",
          dispense_from: new Date(),
          dispense_to: dispenseTo,
          dispensing_status: "1",
          pharmacy_note: "1",
          created_by_userId: userLocalState[0].user.id,
          pharmacy_id:
            pharmacy !== null && pharmacy !== "select" ? pharmacy : null,
          pharmacyReferalsFlag: pharmacy !== null && pharmacy !== "select",
        },
        {
          headers: { Authorization: "Bearer " + userLocalState[0].jwt },
        }
      );
      setResponseMessage(response?.data?.message);
      setNotes("");
      setEnabledSave(false);
      cleanForm();
      setIsLoading(false);
    } catch (error) {
      console.error(error);
      setResponseMessage(error);
      setIsLoading(false);
    }
  };

  const handleSave = async () => {
    await handlePrescriptionSave();
    setSnackbarMessage(t("Prescription created successfully"));
    setSnackbarSeverity("success");
    setOpenSnackbar(true);
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
  };

  const cleanForm = () => {
    setPrescriptionValue("");
    setNotes("");
    setPharmacy("select");
    setDispenseTo("");
  };

  return (
    <div
      style={{ height: "fit-content" }}
      className="shadow p-3 m-2 bg-white rounded-lg col-md-12 col-sm-12 position-relative prescription-card d-flex flex-column justify-content-between"
    >
      {openSnackbar && (
        <div className="col-sm-12 col-md-12 mt-1 text-center">
          <Alert severity={snackbarSeverity}>{snackbarMessage}</Alert>
        </div>
      )}
      {/* Prescription types */}
      <TextField
        id="prescription-types"
        select
        fullWidth
        variant="outlined"
        margin="normal"
        placeholder={t("Select Prescription Type")}
        label={t("Prescription Type")}
        onChange={(e) => {
          setPrescType(e.target.value);
          setPharmacy("select");
        }}
        value={prescType || t("select")}
      >
        <MenuItem value="select">{t("Select")}</MenuItem>
        {prescTypes.map((item, idx) => (
          <MenuItem key={idx} value={item.value}>
            {t(item.label)}
          </MenuItem>
        ))}
      </TextField>
      {/* Pharmacies */}
      {!!prescType && prescType !== "select" && (
        <>
          <TextField
            id="pharmacy-list"
            select
            fullWidth
            variant="outlined"
            margin="normal"
            label={prescType ? t(presTypeObjLabel[prescType]) : ""}
            onChange={(e) => setPharmacy(e.target.value)}
            value={pharmacy || t("select")}
          >
            <MenuItem value="select">{t("Select")}</MenuItem>
            {pharmacies?.length > 0 &&
              pharmacies
                .filter((i) => i.type === prescType)
                .map((item, idx) => (
                  <MenuItem key={idx} value={item.id}>
                    {`${item.name} - ${item.city}`}
                  </MenuItem>
                ))}
          </TextField>
          {/* Dispense To as a date selection */}
          <div className="form-group">
            <label htmlFor="dispense-to">{t("Valida hasta")}</label>
            <input
              type="date"
              className="form-control"
              value={dispenseTo || ""}
              onChange={(e) => setDispenseTo(e.target.value)}
            />
          </div>
          <div className="pb-5">
            <ReactQuill
              theme="snow"
              value={prescriptionValue}
              onChange={(value) => setPrescriptionValue(value)}
              modules={modules}
              formats={formats}
              style={{ height: "200px" }}
            />
          </div>
          <div className="mt-4">
            <Button
              variant="contained"
              color={isLoading ? "secondary" : "primary"}
              onClick={handleSave}
              className="col-md-6"
              disabled={isLoading || !dispenseTo || prescriptionValue === ""}
            >
              {isLoading ? t("Saving...") : t("Save")}
            </Button>
          </div>
        </>
      )}
    </div>
  );
}
